import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'
import {
  FetchTableViewsPayload,
  EditTableViewPayload,
  CreateTableViewPayload,
} from '../types'

export const fetchAllTableViews = (payload: FetchTableViewsPayload) => {
  return axiosInstance.post(`${API_END_POINT.USER_PREFERENCES}/get`, payload)
}

export const editTableView = (
  userId: number,
  payload: EditTableViewPayload
) => {
  return axiosInstance.put(
    `${API_END_POINT.USER_PREFERENCES}/${userId}`,
    payload
  )
}

export const createTableView = (payload: CreateTableViewPayload) => {
  return axiosInstance.post(`${API_END_POINT.USER_PREFERENCES}`, payload)
}
